import { gql } from '@apollo/client';

export const UPDATE_CREDIT_CARD = gql`
  mutation updateCreditCard($billingInformation: BillingInformationInput!, $stripeToken: String!) {
    updateCreditCard(billingInformation: $billingInformation, stripeToken: $stripeToken)
  }
`;

export const ACCOUNT = gql`
  query getAccountAndBillingInformation {
    account: accountData {
      id
      hasCreditCard
      canChangeBillingPlan
      cardInformation {
        brand
        lastFour
      }
      billingInformation {
        address
        city
        company
        country
        firstname
        lastname
        state
        zip
      }
    }
  }
`;
